import React, {Fragment, useEffect, useState} from 'react';
import '../../assets/scss/design.scss';
import LeftSection from './components/LeftSection';
import RightSection from './components/RightSection';
import {useDispatch, useSelector} from 'react-redux';
import {
  calculateCompletedStepsInUserProfile,
  calculateTotalStepsToCompleteProfile,
  openNotificationInToast,
  reloadPage
} from '../../utilities';
import {confirmationEmailService} from '../../services/profile';
import {finishTimeTracker, initTimeTracker} from '../../utilities/timeTracker';
import MetaDecorators from '../../components/MetaDecorators';

function Profile() {
    const {userDetails, status, editStatus} = useSelector((state) => state.profile);
    const [profileStepsCount, setProfileStepsCount] = useState(2);
    const [profileStrength, setProfileStrength] = useState({string: '', number: ''});
    const [strengthColor, setStrengthColor] = useState('');
    const dispatch = useDispatch();

    useEffect(() => {
        if (userDetails && userDetails.users) {
            setProfileStepsCount(calculateTotalStepsToCompleteProfile(userDetails).length);

            const verifyEmailId = localStorage.getItem('verifyEmailId');
            if (verifyEmailId !== null && JSON.parse(verifyEmailId)) {
                if (!userDetails.users.isEmailVerified) {
                    verifyEmail();
                } else {
                    localStorage.removeItem('verifyEmailId');
                    openNotificationInToast('info', '', 'Your email has already verified!');
                }
            } else {
                localStorage.removeItem('verifyEmailId');
            }
        }
    }, [userDetails]);

    useEffect(() => {
        if (userDetails) {
            getProfileStrength();
        }
    }, [profileStepsCount, userDetails]);

    useEffect(() => {
        if (editStatus === 'success') {
            openNotificationInToast('success', 'Success!', 'Profile has been updated!');
            setTimeout(() => {
                reloadPage();
            }, 1000);
        } else if (editStatus === 'failed') {
            openNotificationInToast('error', 'Failed!', 'Profile has not been updated!');
        }
    }, [editStatus]);

    useEffect(() => {
        initTimeTracker('Profile');
        return () => {
            const ttdata = JSON.parse(localStorage.getItem('ttdata'));
            if (ttdata && ttdata.product === 'Profile') {
                finishTimeTracker(ttdata && ttdata.trackerId);
            }
        };
    }, []);

    const verifyEmail = () => {
        confirmationEmailService(userDetails.users.email)
            .then((response) => {
                openNotificationInToast('success', 'Success!', 'Email verification link has been sent to ' + userDetails.users.email);
                localStorage.removeItem('verifyEmailId');
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const getProfileStrength = () => {
        let strength = calculateCompletedStepsInUserProfile(userDetails).length;
        if (strength === 0) {
            setProfileStrength({string: 'Low', number: strength});
            setStrengthColor('#f96161');
        }
        if (strength === 1 && profileStepsCount === 2) {
            setProfileStrength({string: 'Medium', number: strength});
            setStrengthColor('#ffa500');
        }
        if ((strength === 1 && profileStepsCount === 1) || (strength === 2 && profileStepsCount === 2)) {
            setProfileStrength({string: 'High', number: strength});
            setStrengthColor('#4fd688');
        }
    };

    return status === 'fetching' ? (
        <div>Loading...</div>
    ) : userDetails.users ? (
        <Fragment>
            <MetaDecorators/>
            <div className='wrapper profile'>
                <div className='profile_container'>
                    <LeftSection verifyEmail={verifyEmail} profileStepsCount={profileStepsCount}
                                 userDetails={userDetails} profileStrength={profileStrength}
                                 strengthColor={strengthColor}/>
                    <RightSection verifyEmail={verifyEmail} profileStepsCount={profileStepsCount}
                                  userDetails={userDetails} profileStrength={profileStrength}/>
                </div>
            </div>
        </Fragment>
    ) : null;
}

export default Profile;
